// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"0":"16bf1b2a","43":"359cc869","164":"dd1d5e60","501":"db97b84d","543":"79cfb584","787":"b2c3f5bb","834":"d654e807"}[chunkId] + ".chunk.js";
};